import template from './user-control.html';
import controller from './user-control.controller';
import './user-control.scss';

let UserControlComponent = {
  bindings: {
    accountsObservable: '<'
  },
  template,
  controller
};

export default UserControlComponent;



// WEBPACK FOOTER //
// ./src/app/pages/user-control/user-control.component.js